import { authService } from "../authService";
import { validateForOtp, validateCompleteForm } from "./signUpValidation";

/**
 * Handle Get OTP button click
 */
export const createHandleGetOtp = (
  formData,
  fieldValidation,
  setFormErrors,
  setIsLoading,
  setSubmitError,
  setOtpSent,
  setSuccessMessage,
  t,
) => {
  return async () => {
    const validation = validateForOtp(formData, fieldValidation);

    if (!validation.isValid) {
      setFormErrors(validation.errors);
      return;
    }

    setIsLoading((prev) => ({ ...prev, sendingOtp: true }));
    setSubmitError("");

    try {
      const result = await authService.sendOTP(formData.email.trim());

      if (result.success) {
        setOtpSent(true);
        setSuccessMessage(
          "OTP sent to your email address. Please check your inbox.",
        );
      } else {
        setSubmitError(result.error || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("OTP sending error:", error);
      setSubmitError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading((prev) => ({ ...prev, sendingOtp: false }));
    }
  };
};

/**
 * Handle form submission
 */
export const createHandleSubmit = (
  formData,
  fieldValidation,
  setFormErrors,
  setIsLoading,
  setSubmitError,
  setSuccessMessage,
  navigate,
) => {
  return async (e) => {
    e.preventDefault();

    const validation = validateCompleteForm(formData, fieldValidation);

    if (!validation.isValid) {
      setFormErrors(validation.errors);
      return;
    }

    setIsLoading((prev) => ({ ...prev, submitting: true }));
    setSubmitError("");

    try {
      const result = await authService.verifyOTPAndCreateAccount({
        username: formData.username.trim(),
        fullName: formData.fullName.trim(),
        email: formData.email.trim(),
        password: formData.password,
        otp: formData.otp.trim(),
        profileImage: formData.profileImage,
      });

      if (result.success) {
        setSuccessMessage(
          "Account created successfully! Redirecting to sign in...",
        );

        // Redirect to sign in page after short delay
        setTimeout(() => {
          navigate("/signin", {
            state: {
              message: "Account created successfully! Please sign in.",
              email: formData.email.trim(),
            },
          });
        }, 2000);
      } else {
        console.error("Account creation failed with result:", result);
        setSubmitError(
          result.error || "Failed to create account. Please try again.",
        );
      }
    } catch (error) {
      console.error("Account creation error:", error);
      setSubmitError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading((prev) => ({ ...prev, submitting: false }));
    }
  };
};

/**
 * Handle profile image change
 */
export const createHandleImageChange = (
  setFormData,
  formErrors,
  setFormErrors,
) => {
  return (imageData) => {
    setFormData((prev) => ({
      ...prev,
      profileImage: imageData,
    }));

    // Clear any previous profile image errors
    if (formErrors.profileImage) {
      setFormErrors((prev) => ({ ...prev, profileImage: "" }));
    }
  };
};
